import React, { useState, useEffect } from 'react';
import { setDoc, doc, collection, getFirestore, getDocs, writeBatch, where, query, documentId } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { useRoomsContext } from '../../context/RoomsContext'
import NavbarPanel from '../NavbarPanel';
import { useLoginContext } from '../../context/LoginContext'
import Login from '../login/Login';
import { Link } from 'react-router-dom';
import RoomsEditInput from '../roomsEdit/RoomsEditInput';
import PricingButton from './PricingButton';
import { LineWobble } from '@uiball/loaders'

export default function PricingCont() {


  const [loginAnimation, setLoginAnimation] = useState(false)
  const db = getFirestore()
  const { customer } = useParams()
  const { rooms, contextRooms, rerenderF } = useRoomsContext()
  const { loginCheck, planCheck } = useLoginContext()

  const [showRoomsEditor, setShowRoomsEditor] = useState(false)
  const [showExtras, setShowExtras] = useState(false)

  const [newPrice, setNewPrice] = useState()
  const [roomSelected, setRoomSelected] = useState([])
  const [render, setrender] = useState(false)
  const [loader, setLoader] = useState(true)

  const [paymentData, setPaymentData] = useState([])

  const [condition, setCondition] = useState()

  const [openDayCondition, setOpenDayCondition] = useState(false)
  const [openMonthCondition, setOpenMonthCondition] = useState(false)

  const openDayConditionF = () => {
    if (openDayCondition === false) {
      setOpenDayCondition(true)
    } else {
      setOpenDayCondition(false)
    }
  }

  const openMonthConditionF = () => {
    if (openMonthCondition === false) {
      setOpenMonthCondition(true)
    } else {
      setOpenMonthCondition(false)
    }
  }

  useEffect(() => {
    const queryCol = collection(db, `clients/${customer}/payments`)

    getDocs(queryCol)
      .then(resp => setPaymentData(resp.docs.map(bdata => ({ id: bdata.id, ...bdata.data() }))))
      .catch((err) => console.log(err))
  }, [customer, render])


  const renderF = () => {
    if (render === true) {
      setrender(false)
    } else {
      setrender(true)
    }
  }
  useEffect(() => {
    contextRooms.push(customer)
  }, [render])

  useEffect(() => {
    setLoginAnimation(true)
    setTimeout(() => {
      setLoginAnimation(false)
    }, 2000);
  }, [])

  const loaderPromise = new Promise((resolve, reject) => {
    setTimeout(() => { resolve([]); }, 2000);
  });

  loaderPromise.then(() => {
    setLoader(false);
  });


  const handleSubmit = (event) => {
    event.preventDefault();
  }

  const showRooms = () => {
    if (showRoomsEditor === true) {
      setShowRoomsEditor(false)
    } else {
      setShowRoomsEditor(true)
    }
  }

  const showExtra = () => {
    if (showExtras === true) {
      setShowExtras(false)
    } else {
      setShowExtras(true)
    }
  }

  const setRoom = (a) => {
    setRoomSelected([a])
  }


  const editProp = async (a, b) => {

    const batch = writeBatch(db)

    const queryCol = collection(db, `clients/${customer}/rooms`)
    const queryRooms = await query(
      queryCol,
      where(documentId(), 'in', roomSelected.map(e => e)))

    await getDocs(queryRooms)
      .then(resp => resp.docs.forEach(((res) => {
        batch.update(res.ref, { [a]: b })
      })))

    await batch.commit()

    renderF()
  }





  const pushSelection = async (a, b, c) => {
    let arr = a == "day" ? paymentData.find(e => e.id === "extraDays") : paymentData.find(e => e.id === "extraMonths")

    let arrId = a == "day" ? ["extraDays"] : ["extraMonths"]

    const batch = writeBatch(db)
    const queryCollection = collection(db, `clients/${customer}/payments`)

    const queryStatus = await query(
      queryCollection,
      where(documentId(), 'in', arrId.map((e) => e)))

    await getDocs(queryStatus)
      .then(resp => resp.docs.forEach(((res) => {

        batch.update(res.ref, { [b]: c })
      })))

    batch.commit()

    setTimeout(() => {
      renderF()

    }, 100);


  }


  // MODIFY  % OF PLUS OR DISCOUNT

  const chooseCondition = (a) => {
    setCondition(a)
  }


  function paymentDataLoaded(a) {
    return new Promise((resolve, reject) => {

      if(a === undefined || a.length === 0) {
        reject("Not ok")
      } else {
        resolve("ok")
      }
    } )
    
  }

  useEffect(() => {
    if(paymentData !== undefined && paymentData.length !== 0) {
      setStatus(paymentData.find(e => e.id === "bookCondition").condition)
    } else {

    }
  
  }, [paymentData])
  

  const [cancelled, setCancelled] = useState(false)
  const [cancelling, setCancelling] = useState(false)
  const [status, setStatus] = useState()
  const [resToggle, setResToggle] = useState(false)


  const toggleResStatus = () => {

    let condRes = status === true || status === undefined ? false : true

    setCancelling(true)

    setDoc(doc(db, `clients`, `${customer}`, "payments", "bookCondition"), {
      condition: condRes,
    })

    setTimeout(() => {
        setCancelled(true)
        setCancelling(false)


        setTimeout(() => {
          renderF()
        }, 100);
    }, 2000);
    


  }

  return (
    <>
      {loginCheck != true ?

        <div className={loginAnimation === true ? 'logincont loginlogoAnim' : 'logincont'}>
          <p className='logoMicrositeLoading' >HOLDE <span className='logobackMicrosite'>.ar</span></p>

          <Login customer={customer} />
        </div>
        :


        <>
          <div className='dashboardCont'>
            <NavbarPanel rooms={rooms} customer={customer} />
            <p className='sectionTittles'>| PRICING ROOM </p>


            {loader === true ? <div className='weekcalendarloader'>
              <LineWobble
                size={80}
                lineWeight={5}
                speed={1.75}
                color="#576F72" />
            </div> :
              <>

          

                  <>

                  <section className='dashboardCont center2'>
                    <div onClick={showRoomsEditor === false ? showRooms : undefined} className={showRoomsEditor === true ? 'paymentItem column relativePos wfitcont' : "paymentItem relativePos column"} >
                      <button className="ButtonNone" >
                        <p className='beds'> <b>HABITACIONES</b> </p>
                      </button>

                      <div>

                        {showRoomsEditor === true ?
                          <div className='marginTop'>
                            {rooms.map(e =>


                              <div key={e.id} onClick={() => {
                                setRoom(e.id)
                              }}>
                                <RoomsEditInput name={e.roomname} type="text" data={e.price} text={e.price} onchange={(e) => setNewPrice(e.target.value)} edit={editProp} newData={newPrice} prop="price" />
                              </div>
                            )}
                          </div> : <></>}
                        <button className={showRoomsEditor === false ? "displayNone" : 'closeButton'} onClick={() => {
                          showRooms()
                        }}>Cerrar</button>

                      </div>

                    </div>




          

                    <div className='paymentItem relativePos column'>
                    <p className='beds'> <b>TIPO DE RESERVA</b> </p>
                    <p className='minitext margintop2'>Si querés tener un control extra sobre las reservas de tu hospedaje, podés elegir mantenerlas como PENDIENTES hasta tu confirmación. </p>
                    <p className='minitext margintop2'>Tené en cuenta que los lugares se liberarán SOLO si cancelás la reserva. Mientras el estado sea PENDIENTE o CONFIRMADA los lugares permanecerán ocupados. </p>

                    
                    
                    <button className={status === false ? 'switch pending margintop2' : 'switch on margintop2'} onClick={toggleResStatus} > <span className={cancelling === true ? "switchBallCancelling" : status === false ? 'switchBallOff' : 'switchBallOn'}>⬤</span> 
                    </button>


                    <p className={status === false ? 'minitext pending bookConditionText' : 'minitext on bookConditionText'} >{status === false ? "Las reservas se mostrarán como PENDIENTES hasta que las confirmes o canceles en la sección de reservas de tu administrador" : "Las reservas de mostrarán en todo momento como CONFIRMADAS para tus huéspedes."}</p>
                    </div>
                    </section>
                  </>

                
              </>
            }


          </div>

        </>

      }


    </>
  )
}
